import ActionTypes, {ProjectActionTypes} from "../constants/action_types";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";

type Accesstag = {name: string; id: number};

export type AddAccesstagAction = {
  type: ProjectActionTypes["PROJECT_ADD_ACCESS_TAG"]["SUCCESS"];
  payload: Accesstag;
};

const addAccesstag = requestor => (
  organisationId: number,
  projectId: number,
  accesstag: Accesstag,
) =>
  requestor
    .patch(
      `${basePath}/organisation/${organisationId}/project/${projectId}/accesstag/${accesstag.id}`,
      {},
      {withCredentials: true},
    )
    .then(() => accesstag);

export default function actionCreator(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_ADD_ACCESS_TAG,
    addAccesstag(requestor),
  );
}
